import script from "./report.vue?vue&type=script&lang=ts&setup=true"
export * from "./report.vue?vue&type=script&lang=ts&setup=true"

import "./report.vue?vue&type=style&index=0&id=587f409e&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-587f409e"]])

export default __exports__